// OneDrive:IgnoreCodeCoverage

import { createSingleEvent, ISingleEventType, ISingleEvent } from '../SingleEventBase';
import { EventFieldType } from '../IEvent';
import { Trace, ITraceSingleSchema } from './Trace.event';
import { IExtraData } from './IExtraData';
export interface ICaughtErrorSingleSchema extends ITraceSingleSchema {
    /**
     * This is the stack trace of the error returned during the window.onerror handler
     */
    stack: string;
    /**
     * This is the random extra data for the error event
     */
    extraData?: IExtraData;
}

export interface ICaughtError extends ISingleEvent<ICaughtErrorSingleSchema> {
    data: ICaughtErrorSingleSchema;
}

export type CaughtError = ICaughtError;

export const CaughtError: ICaughtErrorType = createSingleEvent<ICaughtErrorSingleSchema>({
    eventName: 'CaughtError,Trace,',
    shortEventName: 'CaughtError',
    critical: true,
    requiresParent: false
}, {
        stack: EventFieldType.String,
        extraData: EventFieldType.Object
    }, Trace);

export interface ICaughtErrorType extends ISingleEventType<ICaughtErrorSingleSchema> {
}
